module.exports = __webpack_public_path__ + "img/vitality-money-Diamond.e414f4a9.svg";